<template>
  <el-popover
    placement="top-start"
    title=""
    width="280"
    trigger="hover"
    class="teu-popover">
    <div class="table-header-popover-custom-content">
      <p>TEU values are estimated based on container size, weight, and shipment type.</p>
      <ul>
        <li>Containers with unknown sizes are typically assigned 1.7-2 TEU based on weight</li>
        <li>Non-containerized shipments are excluded from TEU counts</li>
        <li>Outlier container lengths are capped to prevent inflated values</li>
        <li>LCL shipments are apportioned by weight in multi-container loads</li>
      </ul>
    </div>
    <i 
      slot="reference" 
      class="el-icon-info"/>
  </el-popover>
</template>
  
<script>
export default {
  name: 'TeuPopover'
}
</script>

<style scoped>
.table-header-popover-custom-content {
  max-height: 200px !important;
  overflow: auto;
}

.el-popover {
  .table-header-popover-custom-content {
    p {
      margin-bottom: 16px;
      line-height: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
    ul {
      padding-top: 0;
      padding-bottom: 0;
      margin-left: 16px;
      list-style: disc;
      li {
        padding-top: 0;
        padding-left: 0;

        &:hover {
          color: #344050;
          cursor: unset;
          background: none;
        }

        &:last-child {
          padding-bottom: 16px;
        }
      }
    }
  }
}
</style>
